module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "go-to-top",
    on: {
      "click": function($event) {
        return _vm.paraTopo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-up fa-3x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-296c43d8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/botao-ir-para-topo/index.vue
// module id = dPOl
// module chunks = 5